// Kart Tanımları (Kartlar) sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'cards.list';

export const cardsListGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Kart Tanımları nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Kulüp girişi, turnike ve cüzdan için kullanılan kartları tanımlar, kişiye bağlar ve oturumlarını yönetirsiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    stats: t(`${G}.regions.stats`, 'Özet kartları'),
    filters: t(`${G}.regions.filters`, 'Arama ve filtreler'),
    toolbar: t(`${G}.regions.toolbar`, 'Yeni Kart Ekle / Kart Eşleştirme / ⋮'),
    table: t(`${G}.regions.table`, 'Kart listesi'),
    pagination: t(`${G}.regions.pagination`, 'Sayfalama'),
  },
  steps: [
    {
      region: 'stats',
      title: t(`${G}.s1.title`, '1. Özet kartlarını okuyun'),
      text: t(`${G}.s1.text`, 'Toplam Kart, Kart Tipi sayısı, kartlardaki Toplam Bakiye ve Cüzdan Sayısı üstte görünür.'),
    },
    {
      region: 'toolbar',
      title: t(`${G}.s2.title`, '2. Kart tanımlayın ve kişiye bağlayın'),
      text: t(`${G}.s2.text`, '"Yeni Kart Ekle" ile kartı okutup tipini, cüzdanlarını ve sahibini (cari veya personel) seçersiniz; pencerenin kendi (i) rehberi ayrıntıları anlatır. Çok kart için ⋮ menüsündeki "Toplu Kart Ekle"yi kullanın.'),
      tips: [
        t(`${G}.s2.tip1`, '⋮ > Kart Tipleri: tip adı, renk ve Deposito (₺) tutarı tanımlanır; tablodaki depozito tutarını değiştirip kutudan çıkınca kaydedilir.'),
        t(`${G}.s2.tip2`, '⋮ > Cüzdanlar: cüzdan adı ve döviz (TRY, USD, EUR) tanımlanır.'),
        t(`${G}.s2.tip3`, 'USB okuyucu ile turnike aynı karta farklı numara veriyorsa "Kart Eşleştirme" ile iki numarayı birleştirin.'),
      ],
    },
    {
      region: 'filters',
      title: t(`${G}.s3.title`, '3. Kartı bulun ve listeyi okuyun'),
      text: t(`${G}.s3.text`, 'Kart UID, numara veya cari adıyla arayın; Oturum Durumu (Oturumu Açık / Kapalı) ve Kart Tipi ile süzün. Listede Kart No, Kart UID, Turnike UID, Kart Tipi, Cüzdanlar, Kart Sahibi (Cari / Personel etiketiyle), Toplam Bakiye, Oturum, Geçiş Hakkı ve Durum görünür.'),
      tips: [
        t(`${G}.s3.tip1`, 'Master kartlar yıldızla ve turuncu satırla gösterilir.'),
        t(`${G}.s3.tip2`, 'Geçiş Hakkı yalnız oturumu açık kartlarda gösterilir: kalan/toplam geçiş, "Sınırsız (Günlük)" veya "Tanımsız".'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Oturumu başlatın, teslim alın veya kapatın'),
      text: t(`${G}.s4.text`, 'Satırdaki ⋮ menüsünden: "Oturumu Başlat" kartı müşteriye verilmiş gibi açar; kart kulüp girişindeki Üye Girişleri listesinde görünür ve 1 tek giriş hakkı tanımlanır. Oturumu açık kartta "Oturum Ayrıntıları", "Kartı Teslim Al" ve "Oturumu Kapat" çıkar.'),
      tips: [
        t(`${G}.s4.tip1`, 'Kartı Teslim Al: kart teslim alınır ve oturumu kapatılır. Varsa depozito, iade sorulmadan kapatılmış (iade edilmiş) olarak işaretlenir; muhasebe hareketi oluşturulmaz.'),
        t(`${G}.s4.tip2`, 'Oturumu Kapat: alınan depozito iade edilmemiş ve kartta yüklenen bakiye kalmış olabilir; kapatmadan önce kontrol edin.'),
        t(`${G}.s4.tip3`, 'Kartta UID yoksa oturum açılır ama üye girişi kaydı oluşturulamaz; turnike kartı tanımaz.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s5.title`, '5. Geçiş hakkı tanımlayın'),
      text: t(`${G}.s5.text`, 'Oturumu açık kartta ⋮ > "Geçiş Hakkı Tanımla"yı seçin veya Geçiş Hakkı hücresine tıklayın. Geçiş hakkı satış/ödeme olmadan doğrudan karta tanımlanır; kart, kulüp girişi ekranında tanımlanmış gibi turnikeden geçebilir.'),
      tips: [
        t(`${G}.s5.tip1`, 'Sınırlı (sayaç bazlı): geçiş hakkı sayısını girin (en az 1).'),
        t(`${G}.s5.tip2`, 'Sınırsız (günlük): oturum açık olduğu sürece kart sayaç sınırı olmadan girer.'),
        t(`${G}.s5.tip3`, 'Kartta zaten geçiş hakkı varsa "Tanımla" mevcut hakların üzerine yazar.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s6.title`, '6. Düzenle, master yap, sil'),
      text: t(`${G}.s6.text`, '⋮ menüsünde "Düzenle" kart penceresini açar, "Geçmiş Oturumlar" kartın oturumlarını gösterir. "Master Yap" kartı master yapar: master kart panel bilgisayarının tüm kapılarından geçer. "Master İptal" bunu kaldırır.'),
      tips: [
        t(`${G}.s6.tip1`, 'Sil: kartta hareket kaydı veya aktif oturum varsa kart silinemez.'),
        t(`${G}.s6.tip2`, 'Silinen kartlar ⋮ > Silinen Kartlar sayfasında listelenir ve oradan geri yüklenebilir.'),
      ],
    },
    {
      region: 'pagination',
      title: t(`${G}.s7.title`, '7. Sayfalar ve diğer sayfalar'),
      text: t(`${G}.s7.text`, 'Sayfa başına 10, 25 veya 50 kart gösterebilirsiniz. Üstteki ⋮ menüsünde Kart Oturumları, Silinen Kartlar ve Yenile de bulunur. Başlıktaki (i) düğmesi bu rehberi her zaman yeniden açar.'),
    },
  ],
});
